import {
    AfterViewInit,
    Component,
    EventEmitter,
    inject,
    Output,
    ViewChild
} from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { ChatNandaService } from "@app/shared/services/chat-nanda.service";

@Component({
    selector: "app-nanda-icon",
    imports: [SharedDsnModule, SharedMaterialModule],
    templateUrl: "./nanda-icon.component.html",
    styleUrl: "./nanda-icon.component.scss"
})
export class NandaIconComponent implements AfterViewInit {
    @ViewChild("tooltip") tooltip!: MatTooltip;
    public readonly chatNandaService = inject(ChatNandaService);
    @Output() handleOpenChat = new EventEmitter<void>();

    ngAfterViewInit(): void {}
}
